import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [
    // {
    //     id: 'applications',
    //     title: 'APLICACIONES',
    //     type: 'group',
    //     translate: 'NAV.APPLICATIONS',
    //     icon: 'apps',
    //     hidden: false,
    //     url: null,
    //     classes: null,
    //     exactMatch: false,
    //     externalUrl: false,
    //     openInNewTab: false,
    //     function: null,
    //     badge: null,
    //     children: [
    //         {
    //             id: 'dashboards',
    //             title: 'Principal',
    //             translate: 'NAV.DASHBOARDS',
    //             type: 'collapsable',
    //             icon: 'dashboard',
    //             children: [
    //                 // {
    //                 //     id: 'grafico',
    //                 //     title: 'grafico',
    //                 //     type: 'item',
    //                 //     icon: 'assessment',
    //                 //     url: '/apps/dashboards/grafico'
    //                 // }
    //                 {
    //                     id: 'resumen',
    //                     title: 'Resúmen',
    //                     type: 'item',
    //                     icon: 'assessment',
    //                     url: '/apps/dashboards/resumen'
    //                 }
    //                 // {
    //                 //     id: 'organigrama',
    //                 //     title: 'Organigrama',
    //                 //     type: 'item',
    //                 //     icon: 'device_hub',
    //                 //     url: '/apps/dashboards/organigrama'
    //                 // }
    //             ]
    //         }
    //     ]
    // }, {
    //     id: 'misprocesos',
    //     title: 'Mis Procesos',
    //     icon: 'import_contacts',
    //     type: 'group',
    //     children: [
    //         {
    //             id: 'missolicitudes',
    //             title: 'Mis Solicitudes',
    //             type: 'collapsable',
    //             icon: 'layers',
    //             children: [
    //                 {
    //                     id: 'licencias',
    //                     title: 'Licencias',
    //                     type: 'item',
    //                     icon: 'description',
    //                     url: '/misprocesos/licencias'
    //                 },
    //                 {
    //                     id: 'permisos',
    //                     title: 'Permisos',
    //                     type: 'item',
    //                     icon: 'description',
    //                     url: '/misprocesos/permisos'
    //                 },
    //                 {
    //                     id: 'salud',
    //                     title: 'Salud',
    //                     type: 'item',
    //                     icon: 'description',
    //                     url: '/misprocesos/salud'
    //                 },
    //                 {
    //                     id: 'compensacion',
    //                     title: 'Compensación',
    //                     type: 'item',
    //                     icon: 'description',
    //                     url: '/misprocesos/compensacion'
    //                 }
    //             ]
    //         }
    //     ]
    // }, {
    //     id: 'rrhh',
    //     title: 'Recursos Humanos',
    //     icon: 'supervisor_account',
    //     type: 'group',
    //     children: [

    //         {
    //             id: 'rrhhsolicitudes',
    //             title: 'Solicitudes',
    //             type: 'collapsable',
    //             icon: 'layers',
    //             children: [
    //                 {
    //                     id: 'comision-de-servicio',
    //                     title: 'Comisión de Servicio',
    //                     type: 'item',
    //                     icon: 'description',
    //                     url: '/misprocesos/comision-de-servicio'
    //                 },
    //                 {
    //                     id: 'vacaciones',
    //                     title: 'Vacaciones',
    //                     type: 'item',
    //                     icon: 'description',
    //                     url: '/misprocesos/vacaciones'
    //                 }
    //             ]
    //         },
    //         {
    //             id: 'rrhhservidores',
    //             title: 'Servidores',
    //             type: 'collapsable',
    //             icon: 'layers',
    //             children: [
    //                 {
    //                     id: 'personal',
    //                     title: 'Informacion del Personal',
    //                     type: 'item',
    //                     icon: 'people_outline',
    //                     url: '/rrhh/personal'
    //                 },
    //                 {
    //                     id: 'edicion-de-asistencia',
    //                     title: 'Omisión de Marcaciones',
    //                     type: 'item',
    //                     icon: 'horizontal_split',
    //                     url: '/rrhh/edicion-de-asistencia'
    //                 },
    //                 {
    //                     id: 'desplazamiento-personal',
    //                     title: 'Desplazamiento de Personal',
    //                     type: 'item',
    //                     icon: 'compare_arrows',
    //                     url: '/rrhh/desplazamiento-personal'
    //                 },
    //                 {
    //                     id: 'encargatura',
    //                     title: 'Responsables y Coordinadores',
    //                     type: 'item',
    //                     icon: 'compare_arrows',
    //                     url: '/rrhh/encargaturas'
    //                 }
    //             ]
    //         }
    //     ]
    // }, {
    //     id: 'jefatura',
    //     title: 'Jefatura',
    //     icon: 'account_box',
    //     type: 'group',
    //     children: [
    //         {
    //             id: 'solicitudes-por-aprobar',
    //             title: 'Solicitudes por Aprobar',
    //             type: 'item',
    //             icon: 'ballot',
    //             url: '/rrhh/solicitudes-por-aprobar'
    //         },
    //         {
    //             id: 'rechazar-aprobaciones',
    //             title: 'Anulacion de Solicitudes',
    //             type: 'item',
    //             icon: 'playlist_add_check',
    //             url: '/jefatura/rechazar-aprobaciones'
    //         }
    //     ]
    // }, {
    //     id: 'reportes',
    //     title: 'Reportes',
    //     icon: 'bubble_chart',
    //     type: 'group',
    //     children: [
    //         {
    //             id: 'reportes',
    //             title: 'Mis Procesos',
    //             type: 'collapsable',
    //             icon: 'bar_chart',
    //             children: [
    //                 {
    //                     id: 'mis-asistencias',
    //                     title: 'Mis Asistencias',
    //                     type: 'item',
    //                     icon: 'assignment',
    //                     url: '/reportes/mis-asistencias'
    //                 },
    //                 {
    //                     id: 'mis-solicitudes',
    //                     title: 'Mis Solicitudes',
    //                     type: 'item',
    //                     icon: 'layers',
    //                     url: '/reportes/mis-solicitudes'
    //                 }
    //             ]
    //         },
    //         {
    //             id: 'rrhh',
    //             title: 'RRHH',
    //             type: 'collapsable',
    //             icon: 'show_chart',
    //             children: [
    //                 {
    //                     id: 'marcaciones',
    //                     title: 'Marcaciones',
    //                     type: 'item',
    //                     icon: 'horizontal_split',
    //                     url: '/reportes/marcaciones'
    //                 },
    //                 {
    //                     id: 'inasistencias',
    //                     title: 'Inasistencias',
    //                     type: 'item',
    //                     icon: 'error_outline',
    //                     url: '/reportes/inasistencias'
    //                 },
    //                 {
    //                     id: 'solicitudes-del-personal',
    //                     title: 'Solicitudes del Personal',
    //                     type: 'item',
    //                     icon: 'file_copy',
    //                     url: '/reportes/solicitudes-del-personal'
    //                 },
    //                 {
    //                     id: 'resumen-personal',
    //                     title: 'Resúmen de los Personales',
    //                     type: 'item',
    //                     icon: 'insert_chart',
    //                     url: '/reportes/resumen-personal'
    //                 }
    //             ]
    //         }
    //     ]
    // },
    // {
    //     id: 'mantenedor',
    //     title: 'Mantenedor General',
    //     icon: 'account_box',
    //     type: 'group',
    //     children: [
    //         {
    //             id: 'mantenimiento',
    //             title: 'Mantenimiento',
    //             type: 'collapsable',
    //             icon: 'bar_chart',
    //             children: [
    //                 {
    //                     id: 'fecha-justificacion',
    //                     title: 'Fechas de justificación',
    //                     type: 'item',
    //                     icon: 'assignment',
    //                     url: '/mantenedor/fechas-justificacion'
    //                 },
    //                 {
    //                     id: 'datos-generales',
    //                     title: 'Datos Generales',
    //                     type: 'item',
    //                     icon: 'layers',
    //                     url: '/mantenedor/datos-generales'
    //                 }
    //             ]
    //         }
    //     ]
    // }
];
